import config from '../../../config';
import {checkStatus, authFetch, parseHeadersAndJson} from '../../utils/http';
import {status} from '../../utils/constant';

export default class LiveInterventionService {
  searchByClientAndSubcontractor(clientId, subcontractorId, selectedStatus, page = 0, size = 10) {
    // pageNumber is 0-based on the server side
    return authFetch(`${config.interventionApi}/api/v1/intervention?clientId=${clientId}&subcontractorId=${subcontractorId}&page=${page}&size=${size}&status=${selectedStatus}`)
      .then(checkStatus)
      .then(parseHeadersAndJson)
      .then(({json, headers}) => ({
        interventions: json,
        totalCount: Number(headers.get('X-Total-Count'))
      }));
  }

  getInterventionTree(interventionId) {
    return authFetch(`${config.interventionApi}/api/v1/intervention/${interventionId}/tree`)
      .then(checkStatus)
      .then(response => response.json());
  }

  getInterventionByProjectId(organisationId, projectId) {
    return authFetch(`${config.interventionApi}/api/v1/intervention?organisationId=${organisationId}&projectId=${projectId}`)
      .then(checkStatus)
      .then(response => (response.status === 204 ? null : response.json()));
  }

  addInterventions(interventions) {
    return authFetch(`${config.interventionApi}/api/v1/intervention/invitation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(interventions)
    })
      .then(checkStatus)
      .then(response => response.json());
  }

  accept(interventionId) {
    const data = {
      status: status.ACCEPTED
    };
    return authFetch(`${config.interventionApi}/api/v1/intervention/${interventionId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(checkStatus);
  }

  reject(interventionId, rejectionReason) {
    const data = {
      status: status.REJECTED,
      rejectionReason
    };
    return authFetch(`${config.interventionApi}/api/v1/intervention/${interventionId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(checkStatus);
  }

  resendInvitation(invitationId) {
    return authFetch(`${config.interventionApi}/api/v1/intervention/${invitationId}/resend`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(checkStatus)
      .then(response => response.json());
  }

  searchByQuery(organisationId, query, page, size) {
    return authFetch(`${config.interventionApi}/api/v1/intervention/search?organisationId=${organisationId}&page=${page}&size=${size}&status=${status.ACCEPTED}&status=${status.ENDED}&query=${encodeURIComponent(query)}`)
      .then(checkStatus)
      .then(parseHeadersAndJson)
      .then(({json, headers}) => ({
        interventions: json,
        totalCount: Number(headers.get('X-Total-Count'))
      }));
  }

  getIntervention(interventionId) {
    return authFetch(`${config.interventionApi}/api/v1/intervention/${interventionId}`)
      .then(checkStatus)
      .then(response => (response.status === 204 ? null : response.json()));
  }

  endOrganisationParticipation(interventionId) {
    return authFetch(`${config.interventionApi}/api/v1/intervention/end/${interventionId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(checkStatus);
  }

  removeOrganisationParticipation(interventionId) {
    return authFetch(`${config.interventionApi}/api/v1/intervention/delete/${interventionId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(checkStatus);
  }

  updateProjectUserPermissions(interventionId, projectUserPermissions) {
    return authFetch(`${config.interventionApi}/api/v1/intervention/${interventionId}/user-permissions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(projectUserPermissions)
    })
      .then(checkStatus);
  }

  /*
  data: {
    projectId: projectUserPermission.projectId,
    organisationId: projectUserPermission.organisationId,
  }
  */
  updateProjectUserPermissionsAlreadyDone(interventionId, data) {
    return authFetch(`${config.interventionApi}/api/v1/intervention/${interventionId}/user-permissions`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(checkStatus);
  }

  isIdentificationNumberInProject(registrationNumber, vatIdentificationNumber, projectId, country) {
    return authFetch(`${config.interventionApi}/api/v1/intervention/exists?registrationNumber=${registrationNumber}&vatIdentificationNumber=${vatIdentificationNumber}&projectId=${projectId}&country=${country}`)
      .then(checkStatus)
      .then(() => true)
      .catch(error => {
        if (error.response && error.response.status === 404) {
          return false;
        }

        throw error;
      });
  }

  setInterventionDate(interventionId, date) {
    return authFetch(`${config.interventionApi}/api/v1/intervention/${interventionId}/intervention-date`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({interventionDate: date})
    })
      .then(checkStatus);
  }
}
